module.exports = __webpack_public_path__ + "img/avatar_ico7.b05de421.jpg";